<template>
    <b-container class="bv-example-row">
        <div v-show="stackview == 'main'">
<!--            <b-row class="my-1 justify-content-md-center">-->
<!--                <b-col sm="12" style="text-align: center">-->
<!--                    <h3>Informações de ativação de usuário[B]</h3>-->
<!--                </b-col>-->
<!--            </b-row>-->
<!--            <b-row class="my-1 justify-content-md-center">-->
<!--                <b-col sm="12">-->
<!--                    <hr>-->
<!--                </b-col>-->
<!--            </b-row>-->
            <ValidationObserver ref="form1" v-slot="{ invalid }" @focus="focusForm1">
                <!--                <b-form @submit.prevent="passes(onSubmit)" @reset="resetForm">-->
                <b-form>
                    <b-row class="my-1 justify-content-md-center">
                        <b-col sm="6">
                            <ValidationProvider rules="required|min:3|max:50" name="Nome" v-slot="{ valid, errors }">
                                <label for="feedback-nome" label-align="left">Nome:</label>
                                <b-input
                                        placeholder="Entre com o seu nome"
                                        v-model="ItemAtual.nome"
                                        autocomplete="given-name"
                                        required
                                        @focus="focusForm1"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="nome"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="6">
                            <ValidationProvider rules="required|min:3|max:30" name="Sobrenome"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-sobrenome">Sobrenome:</label>
                                <b-input
                                        placeholder="Entre com o seu sobrenome"
                                        v-model="ItemAtual.sobrenome"
                                        required
                                        autocomplete="family-name"
                                        @focus="focusForm1"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-sobrenome"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="my-1 justify-content-md-center">
                        <b-col sm="5">
                            <ValidationProvider rules="required|min:14|max:14|cpf" name="CPF"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-cpf">CPF(Login):</label>
                                <b-input
                                        placeholder="Entre com o CPF"
                                        required
                                        autocomplete="username"
                                        readonly
                                        v-model="ItemAtual.cpf"
                                        v-mask="['###.###.###-##']"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-cpf"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                          <b-col sm="7">
                            <ValidationProvider rules="required|min:18|max:19" name="CNPJ" v-slot="{ valid, errors }">
                                <label for="feedback-cnpj">CNPJ empresa</label>
                                <b-input
                                        required
                                        placeholder="Entre com o CNPJ"
                                        v-model="ItemAtual.cnpj"
                                        readonly
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-cnpj"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <!-- <b-col sm="5">
                            <ValidationProvider rules="required|min:6|max:18" name="RG" v-slot="{ valid, errors }">
                                <label for="feedback-RG">RG:</label>
                                <b-input
                                        placeholder="Entre com a RG"
                                        required
                                        v-model="ItemAtual.RG"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-RG"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="3">
                            <ValidationProvider rules="required|min:2|max:2" name="UF RG"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-ufrg">UF RG:</label>
                                <b-input
                                        placeholder="Entre com a UF RG"
                                        required
                                        v-model="ItemAtual.UFRG"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-ufrg"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col> -->
                    </b-row>
                    <b-row class="my-1 justify-content-md-center">
                        <b-col sm="6">
                            <ValidationProvider rules="required|min:8|max:18" name="Senha" v-slot="{ valid, errors }">
                                <label for="feedback-pwd">Senha:</label>
                                <b-input
                                        autocomplete="new-password"
                                        placeholder="Entre com a senha"
                                        required
                                        type="password"
                                        v-model="ItemAtual.pwd"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-pwd"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="6">
                            <ValidationProvider rules="required|min:8|max:18|confirmed:Senha" name="Repetir Senha"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-pwd2">Senha(repita para confirmar):</label>
                                <b-input
                                        placeholder="Entre com a senha"
                                        required
                                        autocomplete="new-password"
                                        type="password"
                                        v-model="ItemAtual.pwd2"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-cpf"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="my-1 justify-content-md-center">

                        <b-col sm="6">
                            <ValidationProvider rules="required|min:8|max:70|email" name="Email"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-email">E-mail</label>
                                <b-input
                                        required
                                        autocomplete="email"
                                        placeholder="Entre com o endereço de E-mail"
                                        v-model="ItemAtual.email"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-email"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="6">
                            <ValidationProvider rules="required|min:8|max:70|email|confirmed:Email"
                                                name="Email Confirma"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-email">E-mail(repita para confirmar)</label>
                                <b-input
                                        required
                                        autocomplete="email"
                                        placeholder="Entre com o endereço de E-mail"
                                        v-model="ItemAtual.email2"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-email"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="my-1 justify-content-md-center">
                        <b-col sm="4">
                            <ValidationProvider rules="required|min:14|max:15" name="Celular"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-celular">Celular</label>
                                <b-input
                                        required
                                        placeholder="Entre com o celular"
                                        v-model="ItemAtual.celular"
                                        v-mask="['(##) ####-####', '(##) #####-####']"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-celular"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <!-- <b-col sm="6">
                            <ValidationProvider rules="required|min:14|max:15" name="Telefone"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-telefone">Telefone</label>
                                <b-input
                                        required
                                        placeholder="Telefone"
                                        v-model="ItemAtual.telefone"
                                        v-mask="['(##) ####-####', '(##) #####-####']"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-telefone"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col> -->

                    <!-- </b-row> -->
                    <!-- <b-row class="my-1 justify-content-md-center">
                        <b-col sm="8">
                            <ValidationProvider rules="required|min:3|max:35" name="Endereço"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-endereco">Endereço</label>
                                <b-input
                                        required
                                        autocomplete="address street-address address-level1 address-line1"
                                        placeholder="Entre com o endereço"
                                        v-model="ItemAtual.endereco"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-endereco"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="4">
                            <ValidationProvider rules="required|min:1|max:11" name="Número"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-numero">Número</label>
                                <b-input
                                        required
                                        placeholder="Número"
                                        v-model="ItemAtual.numero"
                                        v-mask="['########']"
                                        masked="false"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-numero"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row> -->
                    <!-- <b-row class="my-1 justify-content-md-center">
                        <b-col sm="8">
                            <ValidationProvider rules="required|min:3|max:30" name="Bairro" v-slot="{ valid, errors }">
                                <label for="feedback-bairro">Bairro</label>
                                <b-input
                                        required
                                        placeholder="Entre com o bairro"
                                        v-model="ItemAtual.bairro"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-bairro"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="4"> -->
                            <!--                            https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#attr-fe-autocomplete-new-password-->
                            <!-- <ValidationProvider rules="required|min:10|max:10" name="CEP"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-cep">CEP</label>
                                <b-input
                                        required
                                        autocomplete="postal-code-cep"
                                        placeholder="Entre com o CEP"
                                        v-model="ItemAtual.cep"
                                        v-mask="['##.###-###']"
                                        :v-masked="true"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-cep"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row> --> 
                    <!-- <b-row class="my-1 justify-content-md-center"> -->
                        <b-col sm="6">
                            <ValidationProvider rules="required|min:3|max:30" name="Cidade" v-slot="{ valid, errors }">
                                <label for="feedback-cidade">Cidade</label>
                                <b-input
                                        required
                                        placeholder="Entre com a cidade"
                                        v-model="ItemAtual.cidade"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-cidade"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="2">
                            <ValidationProvider rules="required|min:2|max:2" name="UF" v-slot="{ valid, errors }">
                                <label for="feedback-UF">UF(Estado)</label>
                                <b-input
                                        required
                                        placeholder="Estado"
                                        v-model="ItemAtual.UF"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-UF"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <!-- <b-row class="my-1 justify-content-md-center"> -->
                        <!-- <b-col sm="12">
                            <ValidationProvider rules="required|min:18|max:19" name="CNPJ" v-slot="{ valid, errors }">
                                <label for="feedback-cnpj">CNPJ empresa</label>
                                <b-input
                                        required
                                        placeholder="Entre com o CNPJ"
                                        v-model="ItemAtual.cnpj"
                                        readonly
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-cnpj"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col> -->
                        <!-- <b-col sm="6">
                            <ValidationProvider rules="required|min:3|max:70" name="Empresa" v-slot="{ valid, errors }">
                                <label for="feedback-empresa">Empresa</label>
                                <b-input
                                        required

                                        placeholder="Entre com o nome da Empresa"
                                        v-model="ItemAtual.empresa"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-empresa"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col> -->
                    <!-- </b-row> -->
                    <!-- <b-row class="my-1 justify-content-md-center">
                        <b-col sm="6">
                            <ValidationProvider rules="required|min:3|max:30" name="Departamento"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-Departamento">Departamento</label>
                                <b-input
                                        required
                                        placeholder="Entre com o Departamento"
                                        v-model="ItemAtual.departamento"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-Departamento"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="6">
                            <ValidationProvider rules="required|min:3|max:40" name="Nome fantasia"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-empresa">Nome fantasia empresa</label>
                                <b-input
                                        required
                                        placeholder="Entre com o nome fantasia da empresa"
                                        v-model="ItemAtual.fantasia"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-empresa"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row> -->
                    <!-- <b-row class="mb-4">
                        <b-col sm="12">
                            <ValidationProvider rules="required|min:3|max:40" name="Cargo/função"
                                                v-slot="{ valid, errors }">
                                <label for="feedback-Cargo">Cargo/função</label>
                                <b-input
                                        required
                                        placeholder="Entre com o cargo/função na empresa"
                                        v-model="ItemAtual.cargo"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        id="feedback-Cargo"></b-input>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row> -->
                    <!-- <b-row class="mb-6">
                        <b-col sm="12">
                            <fieldset style="border: 1px dotted #a2aab2;margin-bottom: 8px;padding-left: 8px;"
                                      class="mb-6">
                                <legend style="width: fit-content;opacity: 0.4;font-size: 16px;font-weight: bold;">[
                                    Cursos ]
                                </legend>
                                <b-row v-for="item in cursos" :key="item.idd">
                                    <b-col sm="12">
                                        <b-form-checkbox
                                                v-model="cursosescolhidos"
                                                :value.integer="item.idd"
                                                size="lg"
                                                disabled
                                                unchecked-value="0"
                                                name="check-button" switch>
                                            <span style="color: black;font-size: 14px;font-weight: bold;"> {{item.curso}}</span>
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row> -->
                                <!--                                                                <b-row>-->
                                <!--                                                                    <b-col>-->
                                <!--                                                                        {{cursosescolhidos}}-->
                                <!--                                                                    </b-col>-->
                                <!--                                                                </b-row>-->
                            <!-- </fieldset>
                        </b-col>
                    </b-row> -->
                    <b-row>
                        <b-col>
                            <div v-html="contrato"
                                 style="background-color: #f0f0f0; padding: 10px;height: 200px;overflow-y: scroll;border: 1px dotted black">
                            </div>

                            <ValidationProvider :rules="{ required: { allowFalse: false } }" name="termo de adesão"
                                                v-slot="{ valid, errors }">
                                <b-form-checkbox
                                        class="mt-3 frmcheckaqui"
                                        required
                                        v-model="ItemAtual.contrato_adesao"
                                        switch
                                        size="lg"
                                        :value="true"
                                        :unchecked-value="false"
                                        name="adesao"
                                        id="feedback-contrato">
                                    Aceito o termo de adesão
                                </b-form-checkbox>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <!--                    <b-button type="button" variant="primary">Enviar</b-button>-->
                    <!--                    <b-button type="reset" variant="danger">Reset</b-button>-->
                    <b-row class="my-1 justify-content-md-center mt-5 mr-2 mb-5 pb-5 pt-5"
                           style="background-color: rgba(154,205,50,0.05);">
                        <b-col sm="10">
                            &nbsp;&nbsp;
                            <!--                            idempresa:{{idempresa}}-->
                            <!--                            razao:{{razao}}-->
                            <!--                            <pre>-->
                            <!--                            {{ItemAtual2}}-->
                            <!--                            </pre>-->
                            <span v-show="invalid" style="color: red;font-weight: bold;">
                                Favor verificar items não preenchidos ou com preenchimento inválido na sua inscrição!
                            </span>
                            <span v-show="!invalid" style="color: blue;font-weight: bold;">
                                Pronto para enviar!
                            </span>

                        </b-col>
                        <b-col sm="2">
                            <b-button :variant="invalid?'warning':'primary'" @click="save" v-show="!invalid"
                                      :disabled="invalid">
                                Enviar
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div style="height: 300px">&nbsp;</div>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
        </div>
    </b-container>
</template>

<script>

    //https://vuejs-tips.github.io/vue-the-mask/

    //https://logaretm.github.io/vee-validate/guide/3rd-party-libraries.html#bootstrapvue
    import { ValidationObserver, ValidationProvider } from "vee-validate";
    //https://logaretm.github.io/vee-validate/guide/rules.html#importing-rules-in-nuxt-js
    //https://codesandbox.io/s/veevalidate-components-vuetify-pij6w?from-embed
    export default {
        name      : "CadastroUsersWordPressC",
        props     : {
            data     : [Array, Object],
            cnpj     : String,
            cpf      : String,
            razao    : String,
            idempresa: Number
        },
        components: {
            ValidationObserver,
            ValidationProvider
        },
        beforeUpdate () { console.log('before update') },
        updated () { console.log('updated') },
        focus () { console.log('updated') },
        data () {
            let m = this;
            console.log('data', this.razao, this.cnpj);
            return {
                contrato2       : 'TERMO DE PRIVACIDADE DA INFORMAÇÃO E POLÍTICA DE SEGURANÇA DO USUÁRIO\n'
                                  + '1.1. O Secovi-PR tomará todas as medidas possíveis para manter a confidencialidade e a segurança descritas nesta cláusula, conforme padrões adotados pela indústria de segurança, realizando análises estáticas de códigos, testes automáticos, verificação e aprimoramento constante de falhas de segurança em suas dependências, com a realização de testes periódicos de penetração. Porém, não responderá por prejuízo que possa ser derivado da violação dessas medidas por parte de terceiros que utilizem as redes públicas ou a internet, subvertendo os sistemas de segurança para acessar as informações de Usuários.\n'
                                  + '1.2. Com a finalidade de garantir a privacidade do Usuário, bem como a segurança de suas Informações, o Secovi-PR se compromete a regularmente reavaliar a sua política de segurança e adaptá-la, conforme necessário.\n'
                                  + '1.3. O Secovi-PR somente utilizará as informações fornecidas pelo Usuário para as seguintes finalidades, com as quais o Usuário expressamente concorda e anui: a) Para enviar ao Usuário qualquer notificação administrativa, alertas e comunicados relevantes para o mesmo; b) Para cumprir com a finalidade do Sistema; c) Identificar o perfil, desejos ou necessidades do Usuário a fim de aprimorar os produtos e/ou serviços oferecidos pelo Sistema; d) Realizar estatísticas genéricas para monitoramento de utilização do Sistema; e) Para pesquisas de marketing, planejamento de projetos do Secovi-PR, e; f) Resolução de problemas no Sistema, verificação e proteção das Informações, do Sistema contra erros, fraudes ou qualquer outro crime eletrônico.\n',
                contrato        : '<div style="width: 100%; text-align: justify;">' +
                                  '<span style="font-family: \'Courier New\';">' +
                                  '<span style="font-size: 14pt;"><strong>TERMO DE PRIVACIDADE DA INFORMA&Ccedil;&Atilde;O E POL&Iacute;TICA DE SEGURAN&Ccedil;A DO USU&Aacute;RIO</strong></span><br /><br />1.1. O Secovi-PR tomar&aacute; todas as medidas poss&iacute;veis para manter a confidencialidade e a seguran&ccedil;a descritas nesta cl&aacute;usula, conforme padr&otilde;es adotados pela ind&uacute;stria de seguran&ccedil;a, realizando an&aacute;lises est&aacute;ticas de c&oacute;digos, testes autom&aacute;ticos, verifica&ccedil;&atilde;o e aprimoramento constante de falhas de seguran&ccedil;a em suas depend&ecirc;ncias, com a realiza&ccedil;&atilde;o de testes peri&oacute;dicos de penetra&ccedil;&atilde;o. Por&eacute;m, n&atilde;o responder&aacute; por preju&iacute;zo que possa ser derivado da viola&ccedil;&atilde;o dessas medidas por parte de terceiros que utilizem as redes p&uacute;blicas ou a internet, subvertendo os sistemas de seguran&ccedil;a para acessar as informa&ccedil;&otilde;es de Usu&aacute;rios.</span></div>\n'
                                  + '<div style="width: 100%; text-align: justify;">' +
                                  '<span style="font-family: \'Courier New\';"><br />1.2. Com a finalidade de garantir a privacidade do Usu&aacute;rio, bem como a seguran&ccedil;a de suas Informa&ccedil;&otilde;es, o Secovi-PR se compromete a regularmente reavaliar a sua pol&iacute;tica de seguran&ccedil;a e adapt&aacute;-la, conforme necess&aacute;rio.</span></div>\n'
                                  + '<div style="width: 100%; text-align: justify;">' +
                                  '<span style="font-family: \'Courier New\';"><br />1.3. O Secovi-PR somente utilizar&aacute; as informa&ccedil;&otilde;es fornecidas pelo Usu&aacute;rio para as seguintes finalidades, com as quais o Usu&aacute;rio expressamente concorda e anui: </span></div>\n'
                                  + '<div style="width: 100%; text-align: justify; padding-left: 40px;">' +
                                  '<span style="font-family: \'Courier New\';">a) Para enviar ao Usu&aacute;rio qualquer notifica&ccedil;&atilde;o administrativa, alertas e comunicados relevantes para o mesmo; </span></div>\n'
                                  + '<div style="width: 100%; text-align: justify; padding-left: 40px;">' +
                                  '<span style="font-family: \'Courier New\';">b) Para cumprir com a finalidade do Sistema; </span></div>\n'
                                  + '<div style="width: 100%; text-align: justify; padding-left: 40px;">' +
                                  '<span style="font-family: \'Courier New\';">c) Identificar o perfil, desejos ou necessidades do Usu&aacute;rio a fim de aprimorar os produtos e/ou servi&ccedil;os oferecidos pelo Sistema; </span></div>\n'
                                  + '<div style="width: 100%; text-align: justify; padding-left: 40px;">' +
                                  '<span style="font-family: \'Courier New\';">d) Realizar estat&iacute;sticas gen&eacute;ricas para monitoramento de utiliza&ccedil;&atilde;o do Sistema; </span></div>\n'
                                  + '<div style="width: 100%; text-align: justify; padding-left: 40px;">' +
                                  '<span style="font-family: \'Courier New\';">e) Para pesquisas de marketing, planejamento de projetos do Secovi-PR, e; </span></div>\n'
                                  + '<div style="width: 100%; text-align: justify; padding-left: 40px;">' +
                                  '<span style="font-family: \'Courier New\';">f) Resolu&ccedil;&atilde;o de problemas no Sistema, verifica&ccedil;&atilde;o e prote&ccedil;&atilde;o das Informa&ccedil;&otilde;es, do Sistema contra erros, fraudes ou qualquer outro crime eletr&ocirc;nico. </span></div>',
                stackview       : 'main',
                cursos          : [],
                cursosescolhidos: [],
                ItemAtual       : {
                    cpf            : this.cpf,
                    pwd            : '',
                    pwd2           : '',
                    email          : '',
                    nome           : '',
                    sobrenome      : '',
                    endereco       : '',
                    bairro         : '',
                    numero         : '',
                    cidade         : '',
                    UF             : '',
                    empresa        : this.razao,
                    idempresa      : this.idempresa,
                    departamento   : '',
                    fantasia       : '',
                    celular        : '',
                    telefone       : '',
                    cep            : '',
                    contrato_adesao: false,
                    cnpj           : this.cnpj,
                    cargo          : ''
                },
            }
        },
        // watch     : {
        //     razao    : {
        //         handler  : function () {
        //             this.ItemAtual.empresa = this.razao;
        //         },
        //         immediate: true,
        //     },
        //     cnpj     : {
        //         handler  : function () {
        //             this.ItemAtual.cnpj = this.cnpj;
        //         },
        //         immediate: true,
        //     },
        //     cpf      : {
        //         handler  : function () {
        //             this.ItemAtual.cpf = this.cpf;
        //         },
        //         immediate: true,
        //     },
        //     idempresa: {
        //         handler  : function () {
        //             this.ItemAtual.idempresa = this.idempresa;
        //         },
        //         immediate: true,
        //     }
        // },
        methods   : {
            focusForm1 () {
                let m = this;
                // console.log('focusForm1', m.razao, m.ItemAtual)
                // m.ItemAtual.empresa = m.razao;
                // m.ItemAtual.idempresa = m.idempresa;
                // m.ItemAtual.cnpj = m.cnpj;
                // m.ItemAtual.cpf = m.cpf;
            },
            save () {
                // debugger;
                let m = this;
                if (this.$refs.form1.validate()) {

                    try {
                        axios({
                                  method      : 'PUT',
                                  // url         : '/getValidarCnpj.php',
                                  responseType: 'json',
                                  data        : {
                                      ...m.ItemAtual,
                                      cursosEscolhidos: m.cursosescolhidos
                                  },
                                  params      : {
                                      op    : 'saveSocioNovo',
                                      typeop: 'novo'
                                  }
                              })
                            .then(function (response) {
                                // m.dt = response.data;
                                // debugger;
                                m.$emit('finalizado');
                            });
                    } catch (e) { }
                    finally { }
                }
            },
            loadDataReview (data) {
                console.log('cadReview.loadDataReview', data);
                let m = this;
                // debugger;
                // m.ItemAtual = data.data;
                m.ItemAtual.cpf = data.CPF;
                m.ItemAtual.cnpj = data.cnpj;
                m.ItemAtual.idempresa = data.idempresa;
                m.ItemAtual.mercadoescolha = data.mercadoescolha;

                m.cursos = data.cursos;
                data.cursos.forEach((a, b) => {
                    m.cursosescolhidos.push(a.idd);
                });

            },
            loadCursos () {
                let m = this;
                if (this.$refs.form1.validate()) {

                    try {
                        axios({
                                  method      : 'POST',
                                  // url         : '/getValidarCnpj.php',
                                  responseType: 'json',
                                  data        : m.ItemAtual,
                                  params      : {
                                      op: 'getCursosCadastro'
                                  }
                              })
                            .then(function (response) {
                                // m.dt = response.data;
                                // debugger;
                                m.cursos = response.data;
                                response.data.forEach((a, b) => {
                                    m.cursosescolhidos.push(a.idd);
                                    // console.log(a.idd,b)
                                });
                                // debugger;
                                //cursosescolhidos
                            });
                    } catch (e) { }
                    finally { }
                }
            }
        },
        created () {
            console.log('created', this.props, this.cpf);

        },
        mounted () {
            console.log('mounted', this.props, this.cpf);
            // this.loadCursos();
            // console.log('nexttick.created');
            // this.$nextTick();
        }

    };
</script>
<style>
    .frmcheckaqui input {
        z-index: 1000000000;
    }
</style>
